var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmallcase(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "SvgjsSvg1001",
    width: 288,
    height: 288,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "SvgjsDefs1002"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG1008",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 288,
    height: 288,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.4 26.9L80 20.6c-.8-.7-2.1-.7-2.8 0L63.8 34H15c-1.1 0-2 .9-2 2v42c0 1.1.9 2 2 2h60c1.1 0 2-.9 2-2V39.2l9.4-9.4c.8-.8.8-2.1 0-2.9zM73.1 76H17V38h42.8L48.7 49.1c-.3.2-.4.6-.5.9l-1.8 6H28.9c-1.1 0-2 .9-2 2s.9 2 2 2h19c.1 0 3.9.1 6.6-.6 1.4-.3 2.4-.6 2.4-.6.4-.1.7-.3.9-.5L73 43.2V76zM55.4 55.1l-4.7 1.2 1.2-4.7 26.7-26.7 3.5 3.5-26.7 26.7z",
    fill: "#404040",
    className: "color000 svgShape"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#404040",
    d: "M1644-650v1684H-140V-650h1784m8-8H-148v1700h1800V-658z",
    className: "color00F svgShape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallcase);
export default __webpack_public_path__ + "static/media/smallcase.367b76629e2142acdabb9b729107b77b.svg";
export { ForwardRef as ReactComponent };